import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
} from '@material-ui/core';

class TabPanel extends Component {
  render() {
    const {
      children,
      index,
      value,
    } = this.props;

    return (
      <div
        role='tabpanel'
        hidden={value !== index}
        id={`tabpanel-${index}`}
      >
        {value === index && (
          <Box>
            {children}
          </Box>
        )}
      </div>
    );
  }
}

TabPanel.defaultProps = {
  children: null,
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default TabPanel;
